export class Logs {

    static name = null;
    static debug = false;
    static color = 'color:#066FA3';

    constructor(type, values = []) {
        return Logs.write(type, values);
    }

    static init(options) {
        if (!options || !options.name) {
            throw new Error("Logs.init requires a name option");
        }

        Logs.name = options.name;
        Logs.debug = !!options.debug;
        if (options.color) Logs.color = options.color;
    }

    static write(type, values = []) {
        if (!Array.isArray(values)) values = [values];

        const prefix = `[${Logs.name}]`;

        if (type === "message") {
            if (!Logs.debug) return false;
            console.log("%c" + prefix, Logs.color, ...values);
            return true;
        }

        if (type === "error") {
            console.error(prefix, ...values);
            return true;
        }

        if (type === "warning") {
            console.warn(prefix, ...values);
            return true;
        }

        console.warn(prefix, "Type de log inconnu", type, values);
        return false;
    }

    static log(type, values = []) {
        return Logs.write(type, values);
    }

}

globalThis.Logs = Logs;
